import { MorganPanel } from '../morgan/MorganPanel';
import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '../../context/AuthContext';
import { TrialBanner } from '../TrialBanner';
import { usePermissionsContext } from '../../lib/permissions';
import { BreadcrumbProvider } from '../../context/BreadcrumbContext';

export function MainLayout() {
  const { user, loading } = useAuth();
  const { billing, loading: permsLoading } = usePermissionsContext();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Trial-onboarding gate: any trialing workspace whose owner hasn't
  // picked Merchant/Broker yet is sent to /trial/onboarding — no matter
  // which protected route they aimed for. Skip when the manifest is
  // still loading (we render a spinner) so we don't bounce prematurely.
  if (!permsLoading && billing
      && billing.plan_status === 'trialing'
      && billing.onboarding_completed === false
      && location.pathname !== '/trial/onboarding') {
    return <Navigate to="/trial/onboarding" replace />;
  }

  return (
    <div className="min-h-screen bg-surface">
      <BreadcrumbProvider>
        <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to main content</a>
        <Sidebar />
        <div className="app-content">
          <Header />
          <main id="main-content" tabIndex={-1} className="app-main focus:outline-none">
            <TrialBanner />
            <Outlet />
            <MorganPanel />
          </main>
        </div>
      </BreadcrumbProvider>
    </div>
  );
}
